"use strict";var e="undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};exports.global=e;
//# sourceMappingURL=global-41509436.js.map
